module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-duotone-900.6bd3ad9d.eot";